export default __webpack_public_path__ + "static/media/Pierre.f36a3922.png";